package com.exura.features.newauth.data.repository

import com.exura.features.newauth.domain.model.ProviderAuthUser
import com.exura.features.newauth.domain.model.ProviderUserRole
import dev.gitlive.firebase.auth.FirebaseAuth
import dev.gitlive.firebase.auth.FirebaseUser
import dev.gitlive.firebase.functions.FirebaseFunctions
import kotlin.random.Random

/**
 * Provider-specific implementation of FirebaseAuthRepository.
 * Handles provider authentication and profile management.
 */
class ProviderFirebaseAuthRepository(
    auth: FirebaseAuth,
) : FirebaseAuthRepository<ProviderAuthUser>(auth) {

    override suspend fun convertToAuthUser(firebaseUser: FirebaseUser): ProviderAuthUser {
        // Extract role from custom claims
        val claims = firebaseUser.getIdTokenResult(true).claims
        val roleString = claims["userRole"] as? String
            ?: "DOCTOR"
        val providerRole = ProviderUserRole.valueOf(roleString)

        return ProviderAuthUser(
            id = firebaseUser.uid,
            email = firebaseUser.email ?: "",
            providerUserRole = providerRole
        )
    }

}
